import React from 'react';
import { createPortal } from 'react-dom';
import Lottie from 'lottie-react';
import Loading from '@/assets/lottie/loading.json';

interface GlobalLoadingProps {
    isOpen: boolean;
}

export const BustlyLoadingAnimation: React.FC = () => (
    <Lottie
        animationData={Loading}
        loop
        style={{ width: 132, height: 100 }}
    />
);

const GlobalLoading: React.FC<GlobalLoadingProps> = ({ isOpen }) => {
    if (!isOpen || window.isShopify) {
        return null;
    }

    const loadingContent = (
        <div
            style={{
                zIndex: 9999,
                position: 'fixed',
                background: '#fff',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
            aria-busy="true"
            aria-live="polite"
        >
            <BustlyLoadingAnimation />
        </div>
    );

    return createPortal(loadingContent, document.body);
};

export default GlobalLoading;
